import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, retry, shareReplay, tap } from 'rxjs/operators';
import { MessageService } from './MessageService.service';
import * as myGlobals from '../../shared/globalcontants'; // CONSTANT FILE ADD ANY CONSTANT VALUE
import { CustomError } from '../models/common/customerror';
import { ToastrService } from 'ngx-toastr';
import { MultilanguageService } from './multilanguage.service';


const httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-Type':  'application/json; odata.metadata=minimal; odata.streaming=true',
        'Accept': 'application/json',
        'tenant': localStorage.getItem('tenant') ? localStorage.getItem('tenant') : ""
      })
};

@Injectable({
  providedIn: 'root',
})

export class HttpRequestService {
  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private toastrService: ToastrService,
    private _MS: MultilanguageService) { }
  /**
     * GET Http Request with token
     * Common service to handle PUT Http Request
     *
     * @param {string} url - Get request end point URL.
     *
     * @return {Observable}
     */

  PostFilehttpMethod(RequestUrl: string, RequestObject: any, Requestparams: any = null, headers: any = null,
    contentType: string = null): Observable<any> {
    try {
      let httpOption;
      RequestUrl = this.getAbsoluteApiURL(RequestUrl);
      if (headers) {
        const headerContentType = (contentType && contentType !== null) ? contentType :
          'application/json; odata.metadata=minimal; odata.streaming=true';
        httpOption = {
          headers: new HttpHeaders({
            'encType': headerContentType,
            'Accept': 'application/json',
          })
        };
      } else {
        httpOption = httpOptions;
      }
      return this.http.post<any>(RequestUrl, RequestObject, httpOption).pipe(
      map((res: any) => {
        return this.handleResponse(res);
      }));

    } catch (error) {
      console.log('erorr occured PosthttpMethod', error);
    }
  }

  GetAiHttpMethod(RequestUrl: string): Observable<any> {
        try {
            RequestUrl = this.getAbsoluteApiURL(RequestUrl);
            const options = httpOptions;
            return this.http.get<any>(RequestUrl, options)
                .pipe(
                    retry(0),
                    shareReplay({ bufferSize: 1, refCount: true }),
                    catchError(this.handleErrors)
                );
        } catch (error) {
            console.log('error occurred GetAiHttpMethod', error);
        }
    }

  GetHttpRequest(RequestUrl: any): Observable<any> {
    RequestUrl = this.getAbsoluteApiURL(RequestUrl);
    const options = httpOptions;
    if (RequestUrl.includes('?$') || RequestUrl.includes('?%24')) {
      let queryName = '';
      if (RequestUrl.includes('?$')) {
        queryName = RequestUrl.split('?$')[1];
        RequestUrl = RequestUrl.split('?$')[0];
      } else if (RequestUrl.includes('?%24')) {
        queryName = RequestUrl.split('?%24')[1];
        RequestUrl = RequestUrl.split('?%24')[0];
      }
      const queryparams = '$' + queryName;
      if (!options.headers.has('oquery')) {
        options.headers = options.headers.append('oquery', queryparams);
      } else {
        options.headers = options.headers.set('oquery', queryparams);
      }
    } else {
      if (options.headers.has('oquery')) {
        options.headers = options.headers.delete('oquery');
      }
    }
    return this.http.get<any>(RequestUrl, options)
      .pipe(
        map((res: any) => {
          return this.handleResponse(res);
        }),
        tap(data => this.log(`fetched data`)),
        catchError(this.handleError('getHeroes', []))
      );
  }

  GethttpPDFMethod(RequestUrl: string, CustomHeaderOptions = null, isSupressed = null): Observable<any> {
    try {
        RequestUrl = this.getAbsoluteApiURL(RequestUrl);
        let httpOption;
        if (CustomHeaderOptions) {
            const headerContentType = 'application/json; odata.metadata=minimal; odata.streaming=true';
             httpOption = {
                    headers: new HttpHeaders({
                        'Content-Type': headerContentType,
                        'Accept': 'application/json',
                    }),
                    params: null,
                    responseType: 'blob',
                    observe: 'response'
                };
        }
        httpOptions.headers = httpOptions.headers.set('supressed', isSupressed?.toString() || 'null');
        return this.http.get(RequestUrl,  httpOption)
            .pipe(
                retry(0),
                shareReplay({ bufferSize: 1, refCount: true }),
                catchError(this.handleErrors)
            );
    } catch (error) {
        console.log('erorr occured GethttpMethod', error);
    }
}

 private handleErrors(error: HttpErrorResponse) {
        let errorReposnse = '';
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            errorReposnse = error.error;
        }
        // Return an observable with a user-facing error message.
        return throwError(
            errorReposnse);
    }

  /**
     * GET Http Request with token
     * Common service to handle Get Http Request
     *
     * @param {string} url - Get request end point URL.
     * @param {number} id - Get request end point URL.
     *
     * @return {Observable}
     */

  GetHttpRequestId(RequestParams: any, RequestUrl: any): Observable<any> {
    RequestUrl = this.getAbsoluteApiURL(RequestUrl);
    return this.http.get<any>(RequestUrl, { params: RequestParams }).pipe(
      map((res: any) => {
        return this.handleResponse(res);
      })
    );
  }

  GethttpBlobMethod(RequestUrl: string, CustomHeaderOptions = null): Observable<Blob> {
    try {
        RequestUrl = this.getAbsoluteApiURL(RequestUrl);

            const rangeValue = CustomHeaderOptions?.Value || 'bytes=0-';

            const headers = new HttpHeaders({
              'Content-Type': 'application/octet-stream;',
              'Accept': 'application/octet-stream',
              'Range': rangeValue,
            });
        return this.http.get(RequestUrl, { headers, observe: 'body', responseType: 'blob'} )
            .pipe(
                retry(0),
                shareReplay({ bufferSize: 1, refCount: true })
            );
    } catch (error) {
        console.log('erorr occured GethttpMethod', error);
    }
}
  /**
 * POST Http Request
 * Common service to handle PUT Http Request
 *
 * @param {string} url - POST request with end point URL.
 * @param {string} data - POST request with data.
 *
 * @return {Observable}
 */
  /** POST: add a new hero to the server */
  putHttpRequest(RequestUrl: any, RequestOption ?: any): Observable<any> {
    RequestUrl = this.getAbsoluteApiURL(RequestUrl);
    return this.http.put<any>(RequestUrl, RequestOption, httpOptions).pipe( // ...using post request
      map((res: any) => {
        return this.handleResponse(res);
      }));
      // .catch((error: any) => Observable.throw(error.json().error || 'Server error')); // ...errors if any
  }

  /**
     * POST Http Request
     * Common service to handle PUT Http Request
     *
     * @param {string} url - POST request with end point URL.
     * @param {string} data - POST request with data.
     *
     * @return {Observable}
     */



  /** POST: add a new hero to the server */
  postHttpRequest(RequestUrl: any, RequestParams: Object): Observable<any> {
    RequestUrl = this.getAbsoluteApiURL(RequestUrl);
    const bodyString = JSON.stringify(RequestParams);
    return this.http.post<any>(RequestUrl, RequestParams, httpOptions).pipe(map((res: any) => {
      return this.handleResponse(res);
    }));
  }
  postHttpRequestwithAuth(RequestUrl: any, RequestParams: Object): Observable<any> {
    RequestUrl = this.getAbsoluteApiURL(RequestUrl);
    return this.http.post<any>(RequestUrl, RequestParams, { headers: myGlobals.reqHeaderURLEncode }).pipe(map((res: any) => {
      return this.handleResponse(res);
    }))
  }

  postHttpRequestFormData(RequestUrl: any, RequestParams: any): Observable<any> {
    RequestUrl = this.getAbsoluteApiURL(RequestUrl);
    let options: any = httpOptions;
    if (RequestParams instanceof FormData) {
      options = { responseType: 'text' as 'json' };
    }

    return this.http.post<any>(RequestUrl, RequestParams, options).pipe(
      map((res: any) => this.handleResponse(res))
    );
  }

  /**
     * @param RequestUrl
     * @param RequestParams
     * @function postHttpRequestParam
     * @output Get Apilcation Menu
     */
    postHttpRequestParam(RequestUrl: any, RequestBodyParams: Object, RequestInputParams: any): Observable<any> {
      RequestUrl = this.getAbsoluteApiURL(RequestUrl);
      const bodyString = JSON.stringify(RequestBodyParams);
      return this.http.post<any>(
        RequestUrl,
        bodyString,
        { headers:
          myGlobals.reqHeaderURLParams,
          params: RequestInputParams
        })
        .pipe(
          map((res: any) => {
            return this.handleResponse(res);
          }),
          catchError((error: any) => of(error))
        );
    }
  /**
   * DELETE Http Request
   * Common service to handle DELETE Http Request
   *
   * @param {string} url - POST request with end point URL.
   *
   * @return {Observable}
   */
  /** POST: add a new hero to the server */
  deleteHttpRequest(RequestUrl: any): Observable<any> {
    RequestUrl = this.getAbsoluteApiURL(RequestUrl);
    return this.http.delete<any>(RequestUrl, httpOptions).pipe(map((res: any) => {
      return this.handleResponse(res);
    }))
  }

  deleteHttpRequestWithBody(RequestUrl: any, RequestParams: Object): Observable<any> {
    RequestUrl = this.getAbsoluteApiURL(RequestUrl);
    return this.http.request<any>('delete', RequestUrl, {
      ...httpOptions,
      body: RequestParams
    }).pipe(map((res: any) => {
      return this.handleResponse(res);
    }));
  }

  /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  handleResponse(res: Response): Response {
    const element = res as any as CustomError; // Okay!
      return res;
  }

  getAbsoluteApiURL(url: any) {
    const baseUrl = window.localStorage.getItem('apiUrl');
    // return `${baseUrl}${url}`;
    return this.replaceBaseUrl(baseUrl, url);
  }

  replaceBaseUrl(Baseurl: string, endPointUrl: string ): string {
    try {
       let customBaseUrl = `${Baseurl}${endPointUrl}`;
       const getServiceName = endPointUrl.split('/')[1];
       const replacableText = `/${getServiceName}/`;
       const replaceServiceUrl = endPointUrl.replace(replacableText, '/');
       switch ( getServiceName.toString().toLowerCase()) {
        case 'inventorys':
            const localInventory = 'https://localhost:44353';
            customBaseUrl = localInventory + replaceServiceUrl;
          break;
          case 'inventorys':
            const localTenantS = 'http://localhost:5000';
            customBaseUrl = localTenantS + replaceServiceUrl;
          break;
         default:
           customBaseUrl = `${Baseurl}${endPointUrl}`;
      }
       return customBaseUrl;
    } catch ( error ) {
        console.error(error);
    }
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add('HeroService: ' + message);
  }

}
